<template>
    <div class="row left-nav-collapsible">
        <div v-if="detailPageOpen" id="detail-page-open">
            <button class="btn details-open-btn" type="button" @click="onDetailPageOpenClose(false)">
                <span> <i class="fa fa-caret-right"></i></span>
            </button>
        </div>
        <TransitionGroup :name="'slide'" key="detail">
            <div v-if="showCloseBtn && !detailPageOpen" id="detail-page-close" key="close">
                <button class="btn text-start details-open-btn" type="button" @click="onDetailPageOpenClose(true)">
                    <span> <i class="fa fa-caret-left"></i></span>
                </button>
            </div>
            <div v-if="!detailPageOpen" id="details-col" @mouseover="onDetailPageHover(true)" key="details-col">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-header-title">History</h5>
                        <button type="button" data-bs-toggle="collapse" href="#collapse-history-div"
                            aria-expanded="true" aria-controls="collapse-history-div" id="collapse-btn"
                            class="btn  btn-sm"> <i class="fa fa-chevron-up float-end"></i></button>
                    </div>
                    <div id="collapse-history-div" class="collapse show" aria-labelledby="collapse-btn-1">
                        <div class="card-body p-3">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <div class="limit-col input-group input-group-sm">
                                        <label class="input-group-text" for="limit">Limit</label>
                                        <input class="form-control" type="number" v-model.number="limit"
                                            :disabled="false" id="limit" style="width: 60px; height: 30px;" />
                                    </div>
                                </div>
                                <button class="btn btn-primary btn-sm" type="button" @click="fetchChatHistory(true)"
                                    :disabled="loading">
                                    <div v-if="loading" class="spinner-border spinner-border-sm mt-1" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    <div v-else>
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </div>
                                </button>
                            </div>
                            <div v-if="chats && chats.length > 0">
                                <list-group id="t2md-chat-history" :editMode="true" :title="'Chat History'"
                                :list="chats" :activeListItem="currentChat?.resourceId"
                                listItemKey="resourceId" :listItemTitle="constructChatTitle"
                                @deleteBtnClick="deleteChatHistory" @selectBtnclick="handleSelect"></list-group>
                            </div>
                            <div v-else>
                                <div class="text-center">
                                    {{ loading ? 'Loading chats...' : 'No chats found!' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="chats?.length > 0 && currentChat">
                    <div class="card-header">
                        <h5 class="card-header-title">Details</h5>
                        <button type="button" data-bs-toggle="collapse" href="#collapse-details-div"
                            aria-expanded="true" aria-controls="collapse-details-div" id="collapse-btn"
                            class="btn  btn-sm"> <i class="fa fa-chevron-up float-end"></i></button>
                    </div>
                    <div id="collapse-details-div" class="collapse show" aria-labelledby="collapse-btn-1">
                        <div class="card-body p-3">
                            <input-field :editable="false" :label="'ID'" type="text"
                                :modelValue="currentChat.resourceId" :toolTip="'Chat Id'" />
                            <input-field :editable="false" :label="'Title'" type="text"
                                :modelValue="currentChat.title" :toolTip="'Chat Title'" />
                            <div v-if="database && table">
                                <input-field :editable="false" :label="'Database'" type="text"
                                    :modelValue="database" :toolTip="'Database Name'" />
                                <input-field :editable="false" :label="'Table'" type="text"
                                    :modelValue="table" :toolTip="'Table Name'" />
                            </div>
                            <input-field :editable="false" :label="'Created At'" type="text"
                                :modelValue="DateTimeFormat(splitCreatedTime(currentChat.createdAt))"
                                :toolTip="'Created Timestamp'" />
                            <input-field :editable="false" :label="'Updated At'" type="text"
                                :modelValue="DateTimeFormat(currentChat.updatedAt)" :toolTip="'Updated Timestamp'" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col" id="main-col" @mouseover="onDetailPageHover(false)" key="main-col">
                <div v-if="chats?.length > 0 && currentChat && currentMessages?.length > 0">
                    <div v-for="(message, index) in currentMessages" :key="index" class="row mb-3">
                        <div :class="message.role === 'user' ? 'align-right' : 'align-left'">

                            <!-- AI Icon -->
                            <span v-if="message.role === 'assistant'" class="icon-circle assistant-icon-circle">
                                <i class="fas fa-robot"></i>
                            </span>

                            <div class="message-bubble"
                                :class="message.role === 'user' ? 'user-message' : 'assistant-message'">
                                <div v-if="message.role == 'user'">
                                    <div v-if="index == 0">
                                        <!-- handling generate query request -->
                                        <p class="my-0 mx-1">{{ message.content?.question }}</p>
                                    </div>
                                    <div v-else>
                                        <!-- handling execute query request -->
                                        <p class="my-0 mx-1">Execute the {{ index == 2 ? 'generated' : 'adjusted' }} query</p>
                                    </div>
                                </div>
                                <div v-else class="p-2">
                                    <div v-if="message.content?.guardrail_action == 'guardrail_intervened'">
                                        <strong class="my-0 mx-1 text-danger">{{ message.content?.guardrail_message }}</strong>
                                    </div>
                                    <div v-else>
                                        <div v-if="index == 1">
                                            <!-- handling generate query response -->
                                            <QueryDisplay :id="currentChat.resourceId + index" title="Response"
                                                :query="message.content?.athena_query"
                                                :text-response="message.content?.text_response" :loading="false"
                                                :database="database" :table="table"
                                                :resourceId="currentChat.resourceId" :hideButtons="true"
                                                :isChatHistory="true" @save-query="saveQuery" />
                                        </div>
                                        <div v-else>
                                            <!-- handling execute query response -->
                                            <QueryDisplay :id="currentChat.resourceId + index"
                                                :analysisResultProp="message.content?.final_answer"
                                                :adjustedQueryProp="message.content?.adjusted_query"
                                                :queryResultsProp="message.content?.query_result" :loading="false"
                                                :database="database" :table="table"
                                                :resourceId="currentChat.resourceId" :hideButtons="true"
                                                :isChatHistory="true" @save-query="saveQuery" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- User Icon -->
                            <span v-if="message.role === 'user'" class="icon-circle user-icon-circle">
                                <i class="fas fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="loading || messagesLoading" class="card card-body">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center card card-body">
                        No data found!
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>
<script>
// import Markdown from "../../components/Markdown.vue";
import QueryDisplay from "../../components/GeneratedQueryDisplay.vue"
import InputField from "../../components/InputField.vue";
import ListGroup from "../../components/ListGroup.vue";
import { DateTimeFormat, relativeTime } from '../../utils/commonFunction';
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'
export default {
    name: "Talk 2 My Data Invocations",
    components: { QueryDisplay, ListGroup, InputField },
    data() {
        return {
            loading: false,
            messagesLoading: false,
            showCloseBtn: false,
            detailPageOpen: false,

            // chat history
            currentChat: null,  
            currentMessages: null,
            limit: null,
        }
    },
    computed: {
        ...mapState({
            chats: state => state.amdp.t2mdChats,
            chatLimit: state => state.amdp.t2mdChatLimit,
        }),
        database() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let database = this.currentMessages[0].content?.db_name
                return database ? database : "";
            }
            return ""
        },
        table() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let table = this.currentMessages[0].content?.table_name
                return table ? table : "";
            }
            return ""
        },
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
            getChats: "amdp/getChats",
            getChatMessages: "amdp/getChatMessages",
        }),
        onDetailPageOpenClose(value) {
            this.showCloseBtn = false;
            this.detailPageOpen = value;
        },
        onDetailPageHover(value) {
            this.showCloseBtn = value;
        },
        async fetchChatHistory(forceGet = false) {
            this.loading = true;
            await this.getChats({ feature: "talk_to_my_data", limit: this.limit, forceGet: forceGet }).catch((error) => {
                console.error("Error getting chat history: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            })
            if (this.chats && this.chats.length > 0) {
                this.handleSelect(this.chats[0], forceGet = true);
            }
            this.loading = false;
        },
        async handleSelect(data, forceGet = false) {
            if (!forceGet && this.currentChat?.resourceId == data.resourceId) return
            this.currentChat = data;

            // get current chat's messages
            this.messagesLoading = true;
            this.currentMessages = null;
            await this.getChatMessages({ feature: "talk_to_my_data", resourceId: this.currentChat.resourceId }).then((response) => {
                this.currentMessages = response.data ? response.data : [];
            }).catch((error) => {
                console.error("Error getting chat messages: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            }).finally(() => {
                this.messagesLoading = false;
            })
        },
        deleteChatHistory(chat) {
            let data = {
                feature: "talk_to_my_data",
                chats: [chat],
                refreshChatsFunction: this.fetchChatHistory,
                screensize: 'xl'
            }
            this.showModal({ component: "deleteChatHistory", data: data });
        },
        async saveQuery(query) {
            this.showModal({
                component: "AddQuery",
                data: {
                    query: {
                        Name: "",
                        Description: "",
                        QueryString: query,
                        Internal: false,
                        Params: []
                    }
                },
            });
            console.log('Saving query:', query);
        },
        convertToRelativeTime(timestamp) {
            return relativeTime(Date.now(), dayjs(timestamp));
        },
        splitCreatedTime(createdAt) {
            let createdTime = null;
            try {
                // split the createdAt string into "{cid}#{timestamp}"
                createdTime = createdAt.split('#')[1];
            } catch (error) {
                console.error("Error extracting created time: ", error);
            }
            return createdTime;
        },
        constructChatTitle(chat) {
            const createdTime = this.convertToRelativeTime(this.splitCreatedTime(chat.createdAt));
            return `<span><strong>${chat.title}</strong></span><span class="badge badge-secondary" style="align-self: flex-start; display: inline-block;">${createdTime}</span>`;
        },
        DateTimeFormat,
    },
    watch: {
        limit(newLimit) {
            this.$store.dispatch("amdp/setT2MDChatLimit", newLimit);
        },
    },
    async mounted() {
        this.$emit("setChat", null);
        this.limit = this.chatLimit;
        await this.fetchChatHistory();
    },
    emits: ["setChat"]
}
</script>
<style scoped>
.limit-col {
    width: 110px;
}

.user-message {
    background-color: rgb(184, 217, 255);
}

.assistant-message {
    /* background-color: rgb(219, 230, 240); */
    background-color: rgb(255, 255, 255);
}

.align-right,
.align-left {
    display: flex;
    align-items: flex-start;
    /* Align all items to the top */
    position: relative;
}

.align-right {
    justify-content: flex-end;
    text-align: right;
}

.align-left {
    justify-content: flex-start;
    text-align: left;
}

.icon-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: 0.4rem;
}

.assistant-icon-circle {
    background-color: #6a737c;
    color: white;
    margin-right: 8px;
    margin-top: 10px;
}

.user-icon-circle {
    background-color: #0d6efd;
    color: white;
    margin-left: 8px;
}

.assistant-icon-circle i,
.user-icon-circle i {
    font-size: 15px;
}

.message-bubble {
    display: inline-block;
    max-width: 90%;
    word-wrap: break-word;
    padding: 10px;
    border-radius: 6px;
}

.card-header {
    background-color: #F9FBFD;
    text-transform: uppercase;
    color: #95AAC9;
    height: 40px;
}

.collapsed .fa {
    transform: rotate(180deg);
}
</style>

<style lang="scss">
@use '../../theme/scss/_user-variables.scss' as *;

body.dark-mode {
    .message-bubble.user-message {
        background-color: $dark-border-color !important;
    }
    .message-bubble.assistant-message {
        background-color: $dark-card-bg !important;
    }
}
</style>